"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addInviteIdToURL = exports.getQueryParams = void 0;
const getQueryParams = () => {
    if (typeof window !== "undefined") {
        return window.location.search;
    }
    return "";
};
exports.getQueryParams = getQueryParams;
const addInviteIdToURL = (url) => {
    if (url === "")
        return url;
    const uriParams = new URLSearchParams(window.location.search);
    const parsedUrl = new URL(url);
    const inviteId = uriParams.get("invite_id");
    if (inviteId && inviteId !== "")
        parsedUrl.searchParams.set("invite_id", inviteId);
    return parsedUrl.toString();
};
exports.addInviteIdToURL = addInviteIdToURL;
//# sourceMappingURL=urlUtils.js.map